/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type ConsentBannerProvider =
  (typeof ConsentBannerProvider)[keyof typeof ConsentBannerProvider];

export const ConsentBannerProvider = {
  HubSpot: "HubSpot",
} as const;
